import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Mail, Phone } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/t3J9pG9VM9s2YNfBdSCinK/Logo_Kementerian_Lingkungan_Hidup_-_Badan_Pengendalian_Lingkungan_Hidup_(2024).png';
export function Footer() {
  return <footer className="bg-secondary-700 text-white pt-16 pb-8" data-id="element-149">
      <div className="container mx-auto px-4 md:px-6" data-id="element-150">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-12 text-left" data-id="element-151">
          {/* Brand - Full width on mobile */}
          <div className="col-span-2 md:col-span-1" data-id="element-152">
            <div className="flex items-center gap-3 mb-4" data-id="element-153">
              <img src={LOGO_URL} alt="Logo KLH/BPLH" className="h-10 w-10 object-contain bg-white rounded-lg p-1" data-id="element-154" />
              <span className="text-xl font-bold tracking-tight" data-id="element-155">
                Indonesia ASRI Hub
              </span>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed mb-6" data-id="element-156">
              Platform Nasional KIE Pengelolaan Sampah. Edukasi, Aksi, dan Data
              untuk Indonesia Bersih.
            </p>
            <div className="text-sm" data-id="element-157">
              <p className="font-semibold text-white mb-1" data-id="element-158">
                Kementerian Lingkungan Hidup /
              </p>
              <p className="font-semibold text-white mb-1" data-id="element-159">
                Badan Pengendalian Lingkungan Hidup
              </p>
              <p className="text-gray-300" data-id="element-160">(KLH/BPLH) Republik Indonesia</p>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-span-1" data-id="element-161">
            <h3 className="text-lg font-semibold mb-4 text-white" data-id="element-162">
              Tautan Cepat
            </h3>
            <ul className="space-y-3" data-id="element-163">
              <li data-id="element-164">
                <Link to="/" className="text-gray-300 hover:text-white transition-colors" data-id="element-165">
                  Beranda
                </Link>
              </li>
              <li data-id="element-166">
                <Link to="/bank-konten" className="text-gray-300 hover:text-white transition-colors" data-id="element-167">
                  Bank Konten
                </Link>
              </li>
              <li data-id="element-168">
                <Link to="/event" className="text-gray-300 hover:text-white transition-colors" data-id="element-169">
                  Event & Aksi
                </Link>
              </li>
              <li data-id="element-170">
                <Link to="/lapor-isu" className="text-gray-300 hover:text-white transition-colors" data-id="element-171">
                  Lapor Isu
                </Link>
              </li>
              <li data-id="element-172">
                <Link to="/track-laporan" className="text-gray-300 hover:text-white transition-colors" data-id="element-173">
                  Lacak Laporan
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div className="col-span-1" data-id="element-174">
            <h3 className="text-lg font-semibold mb-4 text-white" data-id="element-175">Bantuan</h3>
            <ul className="space-y-3" data-id="element-176">
              <li data-id="element-177">
                <Link to="/portal" className="text-gray-300 hover:text-white transition-colors" data-id="element-178">
                  Pilih Portal
                </Link>
              </li>
              <li data-id="element-179">
                <Link to="/series" className="text-gray-300 hover:text-white transition-colors" data-id="element-180">
                  Series Tematik
                </Link>
              </li>
              <li data-id="element-181">
                <Link to="/komunitas" className="text-gray-300 hover:text-white transition-colors" data-id="element-182">
                  Komunitas
                </Link>
              </li>
              <li data-id="element-183">
                <Link to="/login" className="text-gray-300 hover:text-white transition-colors" data-id="element-184">
                  Login Petugas
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact - Full width on mobile */}
          <div className="col-span-2 md:col-span-1" data-id="element-185">
            <h3 className="text-lg font-semibold mb-4 text-white" data-id="element-186">Kontak</h3>
            <ul className="space-y-4" data-id="element-187">
              <li className="flex items-start gap-3" data-id="element-188">
                <MapPin className="h-5 w-5 text-green-400 mt-0.5 flex-shrink-0" data-id="element-189" />
                <span className="text-gray-300 text-sm" data-id="element-190">
                  Gedung Manggala Wanabakti
                  <br data-id="element-191" />
                  Jl. Gatot Subroto, Jakarta Pusat
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-192">
                <Mail className="h-5 w-5 text-green-400 flex-shrink-0" data-id="element-193" />
                <span className="text-gray-300 text-sm" data-id="element-194">
                  kontak@indonesiaasri.id
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-195">
                <Phone className="h-5 w-5 text-green-400 flex-shrink-0" data-id="element-196" />
                <span className="text-gray-300 text-sm" data-id="element-197">(021) 5730191</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8 text-center text-sm text-gray-400" data-id="element-198">
          <p data-id="element-199">
            &copy; {new Date().getFullYear()} Indonesia ASRI Hub - Kementerian
            Lingkungan Hidup / BPLH Republik Indonesia
          </p>
        </div>
      </div>
    </footer>;
}